/* Fransk katalog for locale-invoice-live.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'actionApproval.approve': 'Approuver',
  'actionApproval.approveAction': 'Approuver : {action}',
  'live.reviewTitle': 'Vérifier la facture',
  'live.reviewInvoice': 'Vérifiez la facture ci-dessous avant de l\'approuver.',
  'live.deliveryLabel': 'Envoyer en tant que',
  'live.approveSend': 'Approuver et envoyer',
  'live.approveIssue': 'Approuver et créer',
  'actionApproval.label.send_offer': 'Envoyer le devis',
  'actionApproval.label.send_credit_note': 'Envoyer l\'avoir',
  'actionApproval.label.send_reminder': 'Envoyer un rappel de paiement sans frais',
  'actionApproval.label.post_purchase': 'Enregistrer et comptabiliser l\'achat',
  'actionApproval.label.reverse_purchase': 'Contre-passer l\'achat',
  'actionApproval.label.post_manual_voucher': 'Comptabiliser le justificatif',
  'actionApproval.label.reverse_voucher': 'Contre-passer le justificatif',
  'actionApproval.label.approve_payroll_run': 'Approuver et comptabiliser le traitement de paie',
  'actionApproval.label.reverse_payroll_run': 'Contre-passer le traitement de paie',
  'actionApproval.label.record_payroll_submission': 'Confirmer que l\'A-melding a été transmise en dehors de Plumme',
  'actionApproval.label.close_accounting_year': 'Approuver et clôturer l\'exercice comptable',
  'actionApproval.label.reopen_accounting_year': 'Rouvrir l\'exercice comptable',
  'actionApproval.label.delete_invoice_drafts': 'Supprimer les brouillons de facture',
  'actionApproval.label.delete_purchase_draft': 'Supprimer le brouillon d\'achat',
  'actionApproval.label.delete_payroll_draft': 'Supprimer le brouillon de paie',
  'actionApproval.label.delete_project': 'Supprimer le projet',
  'actionApproval.label.invite_business_member': 'Inviter un utilisateur dans l\'entreprise',
  'actionApproval.label.remove_business_member': 'Retirer l\'accès de l\'utilisateur à l\'entreprise',
  'actionApproval.label.cancel_business_invite': 'Retirer l\'invitation',
  'live.reading': 'Lecture du formulaire et choix de l\'étape suivante …',
  'live.open_editor': 'Ouverture de l\'éditeur de facture …',
  'live.set_layout': 'Changement d\'affichage …',
  'live.set_customer': 'Sélection du client …',
  'live.set_field': 'Remplissage d\'un champ …',
  'live.set_line': 'Remplissage d\'une ligne de facture …',
  'live.remove_line': 'Suppression d\'une ligne de facture …',
  'live.open_customer_form': 'Préparation d\'un nouveau client …',
  'live.open_product_form': 'Préparation d\'un nouveau produit …',
  'live.review': 'Ouverture de l\'aperçu …',
  'live.request_save': 'Préparation pour approbation …',
  'live.finish': 'Vérification du résultat …',
  'live.ask_user': 'Précision nécessaire …',
  'live.approval': 'En attente de votre vérification et de l\'enregistrement du formulaire.',
  'live.customerApproval': 'Vérifiez le nouveau client dans le formulaire. Dès que vous enregistrez, je poursuis la facture.',
  'live.productApproval': 'Vérifiez le nouveau produit, le prix et la TVA dans le formulaire. Dès que vous enregistrez, je poursuis la facture.',
  'live.customerSaved': 'Le client est enregistré. Poursuite de la facture.',
  'live.productSaved': 'Le produit est enregistré. Poursuite de la facture.',
  'live.cancelled': 'La création a été annulée. Le travail sur la facture est en pause.',
  'live.notApplied': 'Le champ n\'a pas été mis à jour comme prévu. Je me suis arrêté pour que vous puissiez vérifier le formulaire.',
  'live.limit': 'J\'ai atteint la limite du nombre d\'étapes. Vérifiez le formulaire et décrivez ce qu\'il reste à faire.',
  'live.done.open_editor': 'L\'éditeur de facture est ouvert.',
  'live.done.set_layout': 'L\'affichage a été modifié.',
  'live.done.set_customer': 'Le client est sélectionné.',
  'live.done.set_field': 'Le champ est rempli et vérifié.',
  'live.done.set_line': 'La ligne de facture est remplie et vérifiée.',
  'live.done.remove_line': 'La ligne de facture a été supprimée.',
  'control.productRequired': 'Le produit ne figure pas dans le catalogue de produits actif.',
  'control.intro': 'Décrivez la facture que vous souhaitez créer. Je remplis le formulaire et peux créer les clients et produits nécessaires. Demandez-moi explicitement d\'émettre et d\'envoyer la facture lorsque vous voulez que je la finalise.',
  'live.create_customer': 'Enregistrement du client …',
  'live.create_product': 'Enregistrement du produit …',
  'live.issue_invoice': 'Émission de la facture …',
  'live.send_invoice': 'Émission et envoi de la facture …',
  'live.finished': 'Le remplissage est terminé. Les modifications ont été vérifiées dans le formulaire de facture.',
  'live.clarification': 'Décrivez ce que vous souhaitez faire ensuite avec la facture.',
  'live.invoiceIssued': 'La facture est émise. Elle n\'a pas été envoyée.',
  'live.invoiceSent': 'La facture a été envoyée par e-mail.',
  'live.emailRequired': 'Pour envoyer, j\'ai besoin de l\'adresse e-mail du client et de l\'e-mail de l\'expéditeur dans les paramètres de l\'entreprise. Indiquez l\'adresse du destinataire avec une nouvelle demande d\'envoi.',
  'live.authorizationRequired': 'Indiquez explicitement ce que vous souhaitez créer ou envoyer.',
  'live.deliveryUncertain': 'L\'envoi a déjà été tenté. Vérifiez le statut d\'envoi dans la liste des factures avant une nouvelle tentative, afin que le client ne reçoive pas la facture en double.',
  'live.deliveryNotSent': 'La facture est émise, mais l\'envoi n\'a pas été confirmé. Vérifiez le statut d\'envoi dans la liste des factures.',
  'live.ambiguousRecord': 'Plusieurs clients ou produits portent le même nom. Sélectionnez d\'abord le bon enregistrement.',
  'live.actionBusy': 'Un enregistrement ou un envoi est déjà en cours.',
  'appControl.changed': 'La page ou l\'entreprise a changé. Vérifiez la page et demandez-moi de continuer.',
  'appControl.unsupported': 'Ce contrôle doit être utilisé directement sur la page.',
  'appControl.authorization': 'Indiquez-moi l\'action que vous souhaitez que j\'effectue.',
  'appControl.manual': 'Terminez cette étape directement sur la page, puis je pourrai continuer.',
  'appControl.option': 'Cette option n\'est pas disponible dans ce champ.',
  'appControl.repeated': 'L\'action a déjà été tentée. Vérifiez le résultat sur la page avant de continuer.',
  'actionApproval.title': 'Approuver l\'action',
  'actionApproval.body': 'Vérifiez l\'action et les informations ci-dessous. L\'approbation ne vaut que pour cette étape.',
  'actionApproval.confirm': 'Approuver et exécuter',
  'actionApproval.proposal': 'Action proposée',
  'actionApproval.context': 'Informations concernées par l\'action',
  'actionApproval.cancel': 'Annuler',
  'actionApproval.mcp': 'Action d\'une IA connectée',
  'actionApproval.failed': 'L\'action n\'a pas pu être exécutée. Demandez une nouvelle proposition et réessayez.',
  'actionApproval.loading': 'Chargement de l\'action ...',
  'actionApproval.done': 'L\'action a été exécutée.',
  'actionApproval.business': 'Entreprise',
  'actionApproval.writeScope': 'L\'IA peut proposer des actions d\'écriture. Chaque action doit être approuvée par vous dans Plumme avant d\'être exécutée.',
  'actionApproval.label.create_invoice_draft': 'Créer un brouillon de facture',
  'actionApproval.label.register_invoice_payment': 'Enregistrer le paiement de la facture',
  'actionApproval.label.save_draft': 'Enregistrer le brouillon',
  'actionApproval.label.send_invoice': 'Envoyer la facture',
  'actionApproval.label.issue_invoice': 'Émettre la facture',
  'actionApproval.label.create_customer': 'Créer un client',
  'actionApproval.label.create_product': 'Créer un produit',
  'actionApproval.label.invoice': 'Facture',
  'actionApproval.label.invoiceId': 'ID de facture',
  'actionApproval.label.customer': 'Client',
  'actionApproval.label.customerName': 'Nom du client',
  'actionApproval.label.currency': 'Devise',
  'actionApproval.label.amount': 'Montant',
  'actionApproval.label.date': 'Date',
  'actionApproval.label.dueDate': 'Date d\'échéance',
  'actionApproval.label.lines': 'Lignes',
  'actionApproval.label.quantity': 'Quantité',
  'actionApproval.label.unitPrice': 'Prix unitaire',
  'actionApproval.label.vatRate': 'Taux de TVA',
  'actionApproval.label.description': 'Description',
  'actionApproval.label.business': 'Entreprise',
  'actionApproval.label.expires': 'Valable jusqu\'au',
  'actionApproval.label.recipientEmail': 'Destinataire',
  'actionApproval.label.fields': 'Champs',
  'actionApproval.label.label': 'Nom',
  'actionApproval.label.value': 'Valeur',
  'actionApproval.label.text': 'Informations de la page',
  'actionApproval.label.action': 'Action',
  'actionApproval.label.click': 'Cliquer',
  'actionApproval.label.fill': 'Remplir',
  'actionApproval.label.select': 'Sélectionner',
  'actionApproval.label.check': 'Modifier la sélection',
  'actionApproval.label.checked': 'Sélectionné',
  'actionApproval.label.post': 'Comptabiliser',
  'actionApproval.label.approve': 'Approuver le traitement de paie',
  'actionApproval.label.close_year': 'Approuver et clôturer l\'exercice comptable',
  'actionApproval.label.reopen_year': 'Rouvrir l\'exercice comptable',
  'actionApproval.label.manage_members': 'Modifier les accès',
  'actionApproval.label.delete': 'Supprimer ou contre-passer',
  'actionApproval.label.submit': 'Transmettre',
  'actionApproval.label.expense': 'Achat',
  'actionApproval.label.supplier': 'Fournisseur',
  'actionApproval.label.year': 'Année',
  'actionApproval.label.records': 'Enregistrements',
});
